<div class="date-range mb-2">
    <span class="date-range__label">Date Range: </span>
    <select style="width: auto; margin-left: 0.25rem;" aria-label="Select Time range" [ngModel]="model" (change)="modelChange.emit($event)" cSelect>
            <option *ngFor="let option of options" [value]="option.value" [selected]="option.value === model">
                {{option.label}}</option>
    </select>
</div>
